import Title from '../Title.jsx';
import { useTranslation } from 'react-i18next';

const CookieList = () => {
  const { t } = useTranslation();

  const cookielist =
    t('cookies_list.table', { returnObjects: true })?.[0] || [];

  return (
    <div className='flex flex-col p-6 md:p-12 gap-6 md:gap-12 text-center max-w-[1600px] mx-auto w-full'>
      <Title>{t('cookies_list.title')}</Title>
      <p className='text-lg lg:text-xl font-light text-gray-500'>
        {t('cookies_list.cookie_subtitle')}
        <span className='font-medium text-primary-red'>Quantessence</span>{' '}
        {t('cookies_list.cookie_common')}{' '}
        {t('cookies_list.cookie_date')}
      </p>
      <table className='table-auto w-full text-left'>
        <thead>
          <tr>
            <th className='border p-2 text-left text-lg lg:text-xl font-medium text-white bg-primary-red w-1/4'>
              {t('cookies_list.table_headers.id')}
            </th>
            <th className='border p-2 text-left text-lg lg:text-xl font-medium text-white bg-primary-red w-1/4'>
              {t('cookies_list.table_headers.domain')}
            </th>
            <th className='border p-2 text-left text-lg lg:text-xl font-medium text-white bg-primary-red w-1/4'>
              {t('cookies_list.table_headers.duration')}
            </th>
            <th className='border p-2 text-left text-lg lg:text-xl font-medium text-white bg-primary-red w-1/4'>
              {t('cookies_list.table_headers.description')}
            </th>
          </tr>
        </thead>
        <tbody>
          {cookielist.map((cookie) => (
            <tr key={cookie.id}>
              <td className='px-2 py-2 border text-primary-blue font-light'>
                {cookie.id}
              </td>
              <td className='px-2 py-2 border text-primary-blue'>
                <a
                  href={`https://${cookie.domain}`}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-blue-500 hover:underline pointer'
                >
                  {cookie.domain}
                </a>
              </td>
              <td className='px-2 py-2 border text-primary-blue font-light'>
                {cookie.duration}
              </td>
              <td className='px-2 py-2 border text-primary-blue font-light'>
                {cookie.description}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CookieList;
